import { z } from 'zod'

export const millsheetTypeSchema = z.enum(['rebar', 'submaterial'])
export type MillsheetType = z.infer<typeof millsheetTypeSchema>

export const millsheetTypeLabels = {
  rebar: '異形棒鋼',
  submaterial: '機械式継手',
}

export const millsheetTypeOptions = Object.entries(millsheetTypeLabels).map(([key, label]) => ({
  value: key,
  label,
}))
